module.exports = __webpack_public_path__ + "img/2x.3fd5263.jpg";